import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGitlabComponent } from './simple-icons-gitlab.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGitlabComponent ],
    exports:      [ SimpleIconsGitlabComponent ],
    bootstrap:    []
})
export class SimpleIconsGitlabModule {}
